import { ViewSnapshotModal } from "./ViewSnapshotModal";

export default {
  title: "DreamStream/Events/ViewSnapshotModal",
  component: ViewSnapshotModal,
  decorators: [
    (Story) => (
      <div>
        <p>Lorem ipsum dolor sit amet, consectetur adip</p>
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <ViewSnapshotModal {...args} />;

export const Default = Template.bind({});
Default.args = {
  isOpen: true,
  onClose: () => alert("closing"),
  onDelete: () => alert("deleting"),
  onClick: () => alert("generating"),
  snapshot: {
    fileName: "Test file name",
    eventName: "Test event",
    date: "01/01/2022",
    time: "12:00:00",
    notes: "This is a test note.",
    totalUsers: 4,
  },
  members: [
    {
      iboNum: "123123123",
      name: "Joe Schmoe",
      pinLevel: 1,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "312312321",
      name: "Joe Schmoe",
      pinLevel: 2,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "4345543345",
      name: "Joe Schmoe",
      pinLevel: 3,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
  ],
};

export const WithNullOrUndefined = Template.bind({});
WithNullOrUndefined.args = {
  isOpen: true,
  members: null,
};

export const WithNullOrUndefinedFields = Template.bind({});
WithNullOrUndefinedFields.args = {
  isOpen: true,
  snapshot: {
    fileName: "Test file name",
    eventName: null,
    time: "12:00:00",
    totalUsers: 19,
  },
  members: [
    {
      iboNum: "123123123",
      name: "Joe Schmoe",
      pinLevel: 1,
      diamond: "Joe Shmeux",
    },
    {
      name: "Joe Schmoe",
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "4345543345",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: null,
      name: null,
      pinLevel: 4,
      platinum: null,
      emerald: "Joe Shmough",
      diamond: null,
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
    {
      iboNum: "789789789",
      name: "Joe Schmoe",
      pinLevel: 4,
      platinum: "Joe Shmow",
      emerald: "Joe Shmough",
      diamond: "Joe Shmeux",
    },
  ],
};
